<div class="share-buttons" [class.disabled]="disabled">
  <a [href]="emailHref" target="_blank" rel="nofollow noreferrer noopener" appButton name="share-via-email" location="share-gallery-link"
    [iconButton]="true" appTooltip="Send Email" shape="round">
    <app-svg src="/assets/icons/email.svg" color="primary"></app-svg>
  </a>
  <a [href]="linkedinHref" target="_blank" rel="nofollow noreferrer noopener" appButton name="share-via-linkedin" location="share-gallery-link"
    [iconButton]="true" appTooltip="Post to LinkedIn" shape="round">
    <app-svg src="/assets/icons/logo/linkedin-color.svg"></app-svg>
  </a>
  <a [href]="twitterHref" target="_blank" rel="nofollow noreferrer noopener" appButton name="share-via-twitter" location="share-gallery-link"
    [iconButton]="true" appTooltip="Post to Twitter" shape="round">
    <app-svg src="/assets/icons/logo/twitter-color.svg"></app-svg>
  </a>
  <a [href]="whatsappHref" target="_blank" rel="nofollow noreferrer noopener" appButton name="share-via-whatsapp" location="share-gallery-link"
    [iconButton]="true" appTooltip="Send on WhatsApp" shape="round">
    <app-svg src="/assets/icons/logo/whatsapp-color.svg"></app-svg>
  </a>
  <button appButton name="share-via-qr-code" location="share-gallery-link" (click)="openQrCodeDialog()" [iconButton]="true"
    appTooltip="Get QR-Code" shape="round">
    <app-svg src="/assets/icons/qr-code.svg"></app-svg>
  </button>
</div>